"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUuid = void 0;
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
function isUuid(input) {
    return UUID_REGEX.test(input);
}
exports.isUuid = isUuid;
//# sourceMappingURL=isUuid.js.map